import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ActivityRecordsRequests = {
    domainName: string,
    create: RequestConfigFunction,
    get: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<number>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
    filterRequest: RequestConfigFunction<{params?: Record<string, string>}>,
}

export const activityRecordsRequests: ActivityRecordsRequests = {
    domainName: 'ActivityRecord',
    create: () => {
        return {
            url: 'activityrecord',
            method: 'POST',
            domainName: 'ActivityRecord',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `activityrecord/${id}`,
            method: 'GET',
        }
    },
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'activityrecord/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    update: (
        id,
    ) => {
        return {
            url: `activityrecord/${id}`,
            method: 'PUT',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `activityrecord/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `activityrecord/${id}/restore`,
            method: 'PATCH',
        }
    },
}

export default activityRecordsRequests
